// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-show[data-v-b98493b6] {\n  display: -webkit-box;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  white-space: pre-line;\n}\n.text-popover-show[data-v-b98493b6] {\n  width: 200px !important;\n  display: inline-block;\n}", ""]);
// Exports
module.exports = exports;
